<template>
  <div class="limiter login_section">

    <div  class="login_container">
      <div  class="wrap-login100">
        <!--        <div v-tilt="{speed: 500, perspective: 1200}">-->
        <!--          <img src="../assets/images/img-01.png" alt="IMG">-->
        <!--        </div>-->
        <form v-if="!loading" class="login_form validate-form">
          <span class="login_title">Вход в систему ЛидМаркет</span>
          <span v-if="typeLogin" @click="typeLogin=''" class="to_back"><i class="fas fa-arrow-left"></i></span>
          <div v-if="!typeLogin" class="toggle_auth_type">
            <span @click="typeLogin='email'">Войти через Email</span>
            <span @click="typeLogin='phone'">Войти через Телефон</span>
          </div>
          <!-- Email -->
          <div v-if="typeLogin==='email'" class="auth_type">
            <div class="input_block validate-input" data-validate="Valid email is required: ex@abc.xyz">
              <p><i class="fa fa-envelope" aria-hidden="true"></i>Email</p>
              <input class="input100" type="text" name="email" placeholder="" v-model="email">
              <span class="floating-placeholder">{{ msg.email }}</span>
              <span class="focus-input100"></span>
              <span class="symbol-input100">
                      </span>
            </div>
            <div class="input_block validate-input" data-validate="Password is required">
              <p><i class="fa fa-lock" aria-hidden="true"></i>Password</p>
              <input class="input100" type="password" name="pass" placeholder="" v-model="password">
              <span class="focus-input100"></span>
              <span class="symbol-input100">
                      </span>
            </div>
          </div>
          <!-- Phone -->
          <div v-if="typeLogin==='phone'" class="auth_type">
            <div class="input_block validate-input" data-validate="Valid email is required: ex@abc.xyz">
              <VuePhoneNumberInput v-model="phone" @update="updateData"/>
            </div>
            <div v-if="typeLogin==='phone'" class="input_block validate-input" data-validate="Password is required">
              <p><i class="fa fa-lock" aria-hidden="true"></i>Push code</p>
              <input class="input100" type="password" name="pass" placeholder="" v-model="code">
              <span class="focus-input100"></span>
              <span class="symbol-input100">
                      </span>
            </div>
          </div>
          <div v-if="typeLogin ==='email'" class="container-login100-form-btn">
            <a class="login_btn" @click="login">
              Авторизация
            </a>
          </div>
          <div v-if="typeLogin ==='phone' && this.isValid" class="container-login100-form-btn">
            <a class="login_btn" @click="login_phone">
              Войти
            </a>
          </div>
          <!--          <div class="text-center p-t-12" v-if="false">-->
          <!--            <span class="txt1">Восстановить пароль</span>-->
          <!--            <router-link-->
          <!--                class="txt2" to="/restore-password"> Email / Password?-->
          <!--            </router-link>-->
          <!--          </div>-->
          <!--          <div class="text-center p-t-136">-->
          <!--            <router-link-->
          <!--                class="txt2" to="/create-account">Create your Account-->
          <!--              <i class="fa fa-long-arrow-right m-l-5" aria-hidden="true"></i>-->
          <!--            </router-link>-->
          <!--          </div>-->
        </form>
        <pulse-loader :loading="loading" :color="color" :size="size" class="loader"></pulse-loader>
      </div>

    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "Login",
  computed: {
    isUserData: function () {
      return this.$store.getters.isUserData
    }

  },
  data() {
    return {
      color: "#2c3e50",
      size: "20px",
      loading: false,
      email: null,
      password: null,
      msg: [],
      phone: null,
      formattedNumber: null,
      typeLogin: null,
      isValid: false,
      code: null,

    }
  },
  async created() {
    if (this.isLoggedIn) {
      await this.$router.push('/')
    }
  }, components: {PulseLoader},
  methods: {
    ...mapActions([
      'getMe'
    ]),
    updateData: function (data) {
      this.formattedNumber = data.formattedNumber ? data.formattedNumber : null
      this.isValid = data.isValid ? data.isValid : false
      if (this.isValid) {
        this.login_phone()
      }
    },
    login_phone: async function () {
      let data_post = {
        phone: this.formattedNumber,
      }
      if (this.code) {
        this.loading = true;
        data_post = {
          phone: this.formattedNumber,
          code: this.code
        }


      }
      this.axios.post(
          `${this.$store.getters.getServerUrl}/login/phone`,
          data_post
      ).then(async response => {
        if (response.data.message) {
          await this.$alert(response.data.message, 'Сообщение', {
            type: 'info',
            hasIcon: true
          })

        } else if (response.data.access_token) {
          this.axios.defaults.headers.common['Authorization'] =
              'Bearer ' + response.data.access_token
          localStorage.setItem('access_token', response.data.access_token)

          this.$store.commit('auth_success', response.data.access_token)
          await this.getMe()
          await this.$router.push('/')
        } else {
          await this.$alert(response.data, 'Сообщение', {
            type: 'info',
            hasIcon: true
          })
        }
      }).catch(error => {
        this.loading = false;
        if (error.response === "undefined") {
          this.$confirm('Серверная ошибка попробуйте позже',
              "Error", "error", {
                reverseButtons: true
              })
        } else {
          this.$confirm(JSON.stringify(error.response.data),
              "Error", "error", {
                reverseButtons: true
              })
        }

      })

    },
    login: async function () {
      this.loading = true;
      this.$store.commit('auth_request')
      const params = new URLSearchParams()
      params.append('username', this.email)
      params.append('password', this.password)
      await this.axios.post(
          `${this.$store.getters.getServerUrl}/auth/jwt/login`,
          params,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
      ).then(async (res) => {

        this.axios.defaults.headers.common['Authorization'] =
            'Bearer ' + res.data.access_token
        localStorage.setItem('access_token', res.data.access_token)

        this.$store.commit('auth_success', res.data.access_token)
        await this.getMe()

        await this.$router.push('/')
      }).catch(error => {
        this.loading = false;
        this.$store.commit('auth_error')
        localStorage.removeItem('auth_success')
        if (error.response !== "undefined") {
          this.$confirm('Серверная ошибка попробуйте позже',
              "Error", "error", {
                reverseButtons: true
              })
        } else {
          this.$confirm(JSON.stringify(error.response.data),
              "Error", "error", {
                reverseButtons: true
              })
        }
      })


    }
  },


}
</script>

<style scoped>
.login_section {
  width: 100%;
  height: 100vh;
  padding: 50px 0;
}

.login_container {
  width: 85%;
  margin: 0 auto;
}

.login_form {
  position: relative;
  margin: 0 auto;
  display: block;
  width: 400px;
  box-shadow: 0 2px 6px 0 rgb(32 33 37 / 10%);
  border-radius: 10px;
  border: 1px solid #ddd;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.to_back {
  cursor: pointer;
  position: absolute;
  right: 3px;
  top: 3px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  opacity: .5;
  transition: all .2s ease;
}

.to_back:hover {
  opacity: 1;
}

.login_title {
  font-weight: 600;
  text-align: center;
  font-size: 20px;
  margin-bottom: 10px;
}

.toggle_auth_type {
  display: flex;
  align-items: center;
}

.toggle_auth_type span {
  display: block;
  text-align: center;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  outline: none;
  padding: 10px 10px;
  text-decoration: none;
  margin: 10px auto;
  background-color: #1967d2;
  transition: all .2s ease;
}

.toggle_auth_type span:hover {
  box-shadow: 1px 1px 10px #1967d2;
}

.input_block {
  position: relative;
  margin: 10px 0;
}

.input_block p {
  margin-bottom: 3px;
  color: #888;
}

.input_block p i {
  margin-right: 5px;
  font-size: 14px;
  color: #666;
}

.input_block input {
  width: 100%;
  border-radius: 10px;
  outline: none;
  border: 1px solid #ddd;
  padding: 8px 20px;
}

.login_btn {
  display: block;
  text-align: center;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 500;
  outline: none;
  padding: 10px 24px;
  text-decoration: none;
  margin: 10px auto;
  background-color: #1967d2;
}

@media screen and (max-width: 768px) {
  .login_container {
    width: 95%;
  }

  .login_form {
    width: 95vw;
  }
}
.loader{
  text-align: center;
}
</style>
